import React from "react";

const Actions = ({
  data,
  onStatusUpdate,
  onDelete,
  onUpdate,
  onUpdateManager,
}) => {
  return (
    <React.Fragment>
      {onStatusUpdate ? (
        <a onClick={() => onStatusUpdate(data)}>
          {data.status === 1 ? (
            <svg
              width="25px"
              height="25px"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
            >
              <path
                d="M12 5C5.63636 5 2 12 2 12C2 12 5.63636 19 12 19C18.3636 19 22 12 22 12C22 12 18.3636 5 12 5Z"
                stroke="#000000"
              />
              <path
                d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z"
                stroke="#000000"
              />
            </svg>
          ) : (
            <svg
              width="25px"
              height="25px"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M20 14.8335C21.3082 13.3317 22 12 22 12C22 12 18.3636 5 12 5C11.6588 5 11.3254 5.02013 11 5.05822C10.6578 5.09828 10.3244 5.15822 10 5.23552M12 9C12.3506 9 12.6872 9.06015 13 9.17071C13.8524 9.47199 14.528 10.1476 14.8293 11C14.9398 11.3128 15 11.6494 15 12M3 3L21 21M12 15C11.6494 15 11.3128 14.9398 11 14.8293C10.1476 14.528 9.47198 13.8524 9.1707 13C9.11386 12.8392 9.07034 12.6721 9.04147 12.5M4.14701 9C3.83877 9.34451 3.56234 9.68241 3.31864 10C2.45286 11.1282 2 12 2 12C2 12 5.63636 19 12 19C12.3412 19 12.6746 18.9799 13 18.9418"
                stroke="#000000"
              />
            </svg>
          )}
        </a>
      ) : (
        ""
      )}

      <a onClick={() => onDelete(data)}>
        <svg
          width="25px"
          height="25px"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M16.5 22.25H7.49999C7.31264 22.2508 7.13176 22.1815 6.99295 22.0556C6.85415 21.9298 6.76748 21.7565 6.74999 21.57L5.24999 5.57C5.23937 5.46613 5.25178 5.36119 5.28635 5.26267C5.32092 5.16415 5.3768 5.07446 5.44999 5C5.51851 4.92149 5.60305 4.85855 5.69792 4.81543C5.79279 4.77231 5.89579 4.75 5.99999 4.75H18C18.1055 4.75109 18.2096 4.77384 18.306 4.81684C18.4023 4.85985 18.4888 4.92219 18.56 5C18.6298 5.07644 18.6827 5.16667 18.7154 5.26485C18.7482 5.36303 18.7599 5.46699 18.75 5.57L17.25 21.57C17.2325 21.7565 17.1458 21.9298 17.007 22.0556C16.8682 22.1815 16.6874 22.2508 16.5 22.25ZM8.17999 20.75H15.82L17.18 6.25H6.81999L8.17999 20.75Z"
            fill="#000000"
          />
          <path
            d="M19 6.25H5C4.80109 6.25 4.61032 6.17098 4.46967 6.03033C4.32902 5.88968 4.25 5.69891 4.25 5.5C4.25 5.30109 4.32902 5.11032 4.46967 4.96967C4.61032 4.82902 4.80109 4.75 5 4.75H19C19.1989 4.75 19.3897 4.82902 19.5303 4.96967C19.671 5.11032 19.75 5.30109 19.75 5.5C19.75 5.69891 19.671 5.88968 19.5303 6.03033C19.3897 6.17098 19.1989 6.25 19 6.25Z"
            fill="#000000"
          />
          <path
            d="M14.5 3.25H9.5C9.30109 3.25 9.11032 3.17098 8.96967 3.03033C8.82902 2.88968 8.75 2.69891 8.75 2.5C8.75 2.30109 8.82902 2.11032 8.96967 1.96967C9.11032 1.82902 9.30109 1.75 9.5 1.75H14.5C14.6989 1.75 14.8897 1.82902 15.0303 1.96967C15.171 2.11032 15.25 2.30109 15.25 2.5C15.25 2.69891 15.171 2.88968 15.0303 3.03033C14.8897 3.17098 14.6989 3.25 14.5 3.25Z"
            fill="#000000"
          />
          <path
            d="M10.25 17.47C10.0519 17.4674 9.86263 17.3876 9.72253 17.2475C9.58244 17.1074 9.50259 16.9181 9.5 16.72V10.28C9.5 10.0811 9.57902 9.89032 9.71967 9.74967C9.86032 9.60902 10.0511 9.53 10.25 9.53C10.4489 9.53 10.6397 9.60902 10.7803 9.74967C10.921 9.89032 11 10.0811 11 10.28V16.72C10.9974 16.9181 10.9176 17.1074 10.7775 17.2475C10.6374 17.3876 10.4481 17.4674 10.25 17.47Z"
            fill="#000000"
          />
          <path
            d="M13.75 17.47C13.5519 17.4674 13.3626 17.3876 13.2225 17.2475C13.0824 17.1074 13.0026 16.9181 13 16.72V10.28C13 10.0811 13.079 9.89032 13.2197 9.74967C13.3603 9.60902 13.5511 9.53 13.75 9.53C13.9489 9.53 14.1397 9.60902 14.2803 9.74967C14.421 9.89032 14.5 10.0811 14.5 10.28V16.72C14.4974 16.9181 14.4176 17.1074 14.2775 17.2475C14.1374 17.3876 13.9481 17.4674 13.75 17.47Z"
            fill="#000000"
          />
        </svg>
      </a>

      <a onClick={() => onUpdate(data)}>
        <svg
          width="25px"
          height="25px"
          viewBox="0 0 64 64"
          xmlns="http://www.w3.org/2000/svg"
          stroke="#000000"
          fill="none"
        >
          <polyline points="45.56 46.83 45.56 56.26 7.94 56.26 7.94 20.6 19.9 7.74 45.56 7.74 45.56 21.29" />
          <polyline points="19.92 7.74 19.9 20.6 7.94 20.6" />
          <line x1="13.09" y1="47.67" x2="31.1" y2="47.67" />
          <line x1="13.09" y1="41.14" x2="29.1" y2="41.14" />
          <line x1="13.09" y1="35.04" x2="33.1" y2="35.04" />
          <line x1="13.09" y1="28.94" x2="39.1" y2="28.94" />
          <path d="M34.45,43.23l.15,4.3a.49.49,0,0,0,.62.46l4.13-1.11a.54.54,0,0,0,.34-.23L57.76,22.21a1.23,1.23,0,0,0-.26-1.72l-3.14-2.34a1.22,1.22,0,0,0-1.72.26L34.57,42.84A.67.67,0,0,0,34.45,43.23Z" />
          <line x1="50.2" y1="21.7" x2="55.27" y2="25.57" />
        </svg>
      </a>
      {onUpdateManager ? (
        <a onClick={() => onUpdateManager(data)}>
          <svg
            width="25px"
            height="25px"
            viewBox="0 0 20 20"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g id="layer1">
              <path
                d="M 10 0 C 4.4830748 0 0 4.4830748 0 10 C 0 15.516925 4.4830748 20 10 20 C 10.686108 20 11.353096 19.923761 12 19.791016 L 12 18.767578 C 11.357372 18.916361 10.689085 19 10 19 C 7.7805094 19 5.7554759 18.195439 4.1875 16.867188 L 4.2871094 16.835938 L 5.0878906 16.615234 L 5.9003906 16.427734 L 6.7167969 16.273438 L 6.9472656 16.216797 L 7.1699219 16.123047 L 7.3710938 15.996094 L 7.5507812 15.835938 L 7.7011719 15.652344 L 7.8222656 15.443359 L 7.9101562 15.220703 L 7.9570312 14.986328 L 7.9707031 14.748047 L 7.9433594 14.509766 L 7.8789062 14.279297 L 7.7792969 14.0625 L 7.6484375 13.865234 L 7.4902344 13.644531 L 7.3535156 13.416016 L 7.0742188 12.855469 L 6.8261719 12.279297 L 6.609375 11.693359 L 6.4238281 11.09375 L 6.2734375 10.486328 L 6.1542969 9.8710938 L 6.0683594 9.2519531 L 6.015625 8.6289062 L 6 8.0019531 L 6.0195312 7.609375 L 6.078125 7.2207031 L 6.171875 6.8398438 L 6.3046875 6.4707031 L 6.4726562 6.1152344 L 6.6738281 5.7792969 L 6.9082031 5.4628906 L 7.1699219 5.171875 L 7.4628906 4.9082031 L 7.7773438 4.6738281 L 8.1152344 4.4746094 L 8.4707031 4.3046875 L 8.8398438 4.1738281 L 9.21875 4.078125 L 9.6074219 4.0195312 L 10 4 L 10.392578 4.0195312 L 10.78125 4.078125 L 11.160156 4.1738281 L 11.529297 4.3046875 L 11.886719 4.4746094 L 12.222656 4.6738281 L 12.537109 4.9082031 L 12.830078 5.171875 L 13.091797 5.4628906 L 13.326172 5.7792969 L 13.527344 6.1152344 L 13.695312 6.4707031 L 13.828125 6.8398438 L 13.923828 7.2207031 L 13.982422 7.609375 L 14 8.0019531 L 13.984375 8.6289062 L 13.931641 9.2519531 L 13.845703 9.8710938 L 13.728516 10.486328 L 13.576172 11.09375 L 13.390625 11.693359 L 13.234375 12.117188 C 13.541423 11.400474 14.085761 10.814969 14.757812 10.429688 L 14.833984 10.035156 L 14.925781 9.359375 L 14.982422 8.6816406 L 15 8.0019531 L 14.982422 7.5664062 L 14.923828 7.1328125 L 14.830078 6.7070312 L 14.697266 6.2910156 L 14.53125 5.8886719 L 14.330078 5.5 L 14.097656 5.1328125 L 13.830078 4.7871094 L 13.537109 4.4648438 L 13.212891 4.171875 L 12.869141 3.90625 L 12.5 3.6699219 L 12.113281 3.46875 L 11.710938 3.3027344 L 11.294922 3.1699219 L 10.867188 3.0761719 L 10.435547 3.0195312 L 10 3 L 9.5644531 3.0195312 L 9.1328125 3.0761719 L 8.7050781 3.1699219 L 8.2890625 3.3027344 L 7.8867188 3.46875 L 7.5 3.6699219 L 7.1328125 3.90625 L 6.7871094 4.171875 L 6.4628906 4.4648438 L 6.1699219 4.7871094 L 5.9042969 5.1328125 L 5.6699219 5.5 L 5.46875 5.8886719 L 5.3027344 6.2910156 L 5.1699219 6.7070312 L 5.0761719 7.1328125 L 5.0195312 7.5664062 L 5 8.0019531 L 5.0175781 8.6816406 L 5.0742188 9.359375 L 5.1660156 10.035156 L 5.2949219 10.703125 L 5.4589844 11.361328 L 5.6601562 12.013672 L 5.8984375 12.652344 L 6.1660156 13.275391 L 6.4707031 13.884766 L 6.6523438 14.193359 L 6.8632812 14.484375 L 6.9296875 14.595703 L 6.9648438 14.720703 L 6.96875 14.847656 L 6.9375 14.974609 L 6.875 15.087891 L 6.7871094 15.181641 L 6.6777344 15.25 L 6.5527344 15.287109 L 5.6953125 15.449219 L 4.84375 15.646484 L 4.0019531 15.878906 L 3.375 16.080078 C 1.9045777 14.478558 1 12.349397 1 10 C 1 5.0235149 5.0235149 1 10 1 C 14.976485 1 19 5.0235149 19 10 C 19 10.320097 18.979986 10.634169 18.947266 10.945312 C 19.294443 11.278158 19.578734 11.675211 19.769531 12.123047 C 19.918106 11.438148 20 10.728954 20 10 C 20 4.4830748 15.516925 0 10 0 z M 16.5 11 C 15.12521 11 14 12.12521 14 13.5 L 14 15 L 13 15 L 13 20 L 20 20 L 20 15 L 19 15 L 19 13.5 C 19 12.12521 17.87479 11 16.5 11 z M 16.5 12 C 17.334349 12 18 12.665651 18 13.5 L 18 15 L 15 15 L 15 13.5 C 15 12.665651 15.665651 12 16.5 12 z M 14 16 L 19 16 L 19 19 L 14 19 L 14 16 z "
                //style={{fill:#222222; fill-opacity:1; stroke:none; stroke-width:0px;}}
              />
            </g>
          </svg>
        </a>
      ) : (
        ""
      )}
    </React.Fragment>
  );
};

export default Actions;
